import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function SupportPage() {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      
      <main className="max-w-4xl mx-auto px-6 py-24">
        <h1 className="text-5xl font-bold mb-4 text-[#222222]" style={{ fontFamily: 'Literata, serif' }}>
          Support
        </h1>
        <p className="text-sm text-[#222222]/50 mb-12">Last updated: {currentDate}</p>

        <div className="prose prose-lg max-w-none">
          {/* Contact Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-4 text-[#222222]" style={{ fontFamily: 'Literata, serif' }}>
              Get in Touch
            </h2>
            <p className="text-[#222222]/70 leading-relaxed mb-4">
              We're here to help! If you have questions, feedback, or need assistance with the I Say I Am app, please reach out to us:
            </p>
            <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
              <p className="text-[#222222]/70 mb-2">
                <strong className="text-[#222222]">Email:</strong>{' '}
                <a href="mailto:hello@thinkheart.co" className="text-[#D4A574] hover:text-[#B8935F] transition-colors">
                  hello@thinkheart.co
                </a>
              </p>
              <p className="text-[#222222]/70 text-sm">
                We typically respond within 24-48 hours.
              </p>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-6 text-[#222222]" style={{ fontFamily: 'Literata, serif' }}>
              Frequently Asked Questions
            </h2>

            <div className="space-y-6">
              <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
                <h3 className="text-xl font-semibold mb-3 text-[#222222]">
                  How do I download the app?
                </h3>
                <p className="text-[#222222]/70 leading-relaxed">
                  The I Say I Am app is available on the App Store for iOS devices and Google Play for Android devices. Search for "I Say I Am" or use the official website at isayiam.app to download it for free.
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
                <h3 className="text-xl font-semibold mb-3 text-[#222222]">
                  Is my data private?
                </h3>
                <p className="text-[#222222]/70 leading-relaxed">
                  Yes! All your journal entries, reflections, and affirmations are stored locally on your device. We don't upload your personal content to our servers. For more details, check our{' '}
                  <Link to="/privacy-policy" className="text-[#D4A574] hover:text-[#B8935F] transition-colors">
                    Privacy Policy
                  </Link>.
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
                <h3 className="text-xl font-semibold mb-3 text-[#222222]">
                  Can I sync my data across devices?
                </h3>
                <p className="text-[#222222]/70 leading-relaxed">
                  Yes! You can enable cloud sync through iCloud (iOS) or Google Drive (Android) to back up your entries and access them across multiple devices.
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
                <h3 className="text-xl font-semibold mb-3 text-[#222222]">
                  How do subscriptions work?
                </h3>
                <p className="text-[#222222]/70 leading-relaxed">
                  Premium features are available through a one-time in-app purchase managed by the App Store or Google Play. You can manage purchases anytime through your device settings.
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
                <h3 className="text-xl font-semibold mb-3 text-[#222222]">
                  How do I request a refund?
                </h3>
                <p className="text-[#222222]/70 leading-relaxed">
                  Refunds are handled directly by Apple or Google, not by us. For iOS, visit the App Store and request a refund through your purchase history. For Android, go to Google Play and follow their refund process.
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
                <h3 className="text-xl font-semibold mb-3 text-[#222222]">
                  The app isn't working properly. What should I do?
                </h3>
                <p className="text-[#222222]/70 leading-relaxed">
                  Try these steps first:
                </p>
                <ul className="list-disc list-inside text-[#222222]/70 leading-relaxed mt-2 space-y-1">
                  <li>Restart the app</li>
                  <li>Check for app updates in the App Store or Google Play</li>
                  <li>Restart your device</li>
                  <li>Reinstall the app (your data should be backed up if cloud sync is enabled)</li>
                </ul>
                <p className="text-[#222222]/70 leading-relaxed mt-3">
                  If the issue persists, contact us at{' '}
                  <a href="mailto:hello@thinkheart.co" className="text-[#D4A574] hover:text-[#B8935F] transition-colors">
                    hello@thinkheart.co
                  </a>{' '}
                  with details about the problem.
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
                <h3 className="text-xl font-semibold mb-3 text-[#222222]">
                  Can I suggest a new feature?
                </h3>
                <p className="text-[#222222]/70 leading-relaxed">
                  Absolutely! We love hearing from our users. Send your ideas to{' '}
                  <a href="mailto:hello@thinkheart.co" className="text-[#D4A574] hover:text-[#B8935F] transition-colors">
                    hello@thinkheart.co
                  </a>{' '}
                  and we'll consider them for future updates.
                </p>
              </div>
            </div>
          </section>

          {/* Additional Resources */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-6 text-[#222222]" style={{ fontFamily: 'Literata, serif' }}>
              Additional Resources
            </h2>
            <div className="space-y-3">
              <Link 
                to="/privacy-policy" 
                className="block bg-white/60 backdrop-blur-sm rounded-lg p-4 border border-[#222222]/10 hover:border-[#D4A574] transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="text-[#222222] font-medium">Privacy Policy</span>
                  <i className="ri-arrow-right-line text-[#D4A574]"></i>
                </div>
              </Link>
              <Link 
                to="/terms-of-service" 
                className="block bg-white/60 backdrop-blur-sm rounded-lg p-4 border border-[#222222]/10 hover:border-[#D4A574] transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="text-[#222222] font-medium">Terms of Service</span>
                  <i className="ri-arrow-right-line text-[#D4A574]"></i>
                </div>
              </Link>
            </div>
          </section>

          {/* Company Info */}
          <section className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-[#222222]/10">
            <h2 className="text-2xl font-bold mb-4 text-[#222222]" style={{ fontFamily: 'Literata, serif' }}>
              About Think Heart Apps AB
            </h2>
            <p className="text-[#222222]/70 leading-relaxed">
              I Say I Am is developed by Think Heart Apps AB, a Swedish company dedicated to creating meaningful wellness tools that help people cultivate daily alignment, clarity, and inner strength.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
